import { onBeforeMount } from 'vue-demi';
import { RECEIVE_CODE } from '../common/constant';
import Toast from '@futuweb/future-ui/es/toast';
import '@futuweb/future-ui/es/toast/style/css';
import $t from '../common/i18n';
const { useCommonApi, useUser, useEnv, useBehaviour } = require('@fegobull/webapi').use;
const { isLogin } = useUser();
const { runBehaviour } = useBehaviour();
const { isPreRender } = useEnv();
const { get, post } = useCommonApi('quote-activity');

export default (props, { setMainStatus, setModalStatus }) => {
    // 拉取活动状态
    const getTotalViewActivity = async () => {
        Toast.loading({
            toastClass: 'silky-loading',
            duration: 0
        });
        try {
            const data = await get('get-total-view-activity');
            setMainStatus(data.receiveStatus);
            Toast.close();
        } catch (failRsp) {
            Toast.error($t('fetch_fail'));
        }
    };

    // 领取行情卡
    const receiveQuoteActivity = async () => {
        if (!isLogin) {
            return runBehaviour(null, { type: 'login' });
        }
        Toast.loading({
            toastClass: 'silky-loading',
            duration: 0
        });
        try {
            await post('receive-total-view-activity', {
                market: props.market
            });
            Toast.close();
        } catch ({ code }) {
            Toast.close();
            if (Object.values(RECEIVE_CODE).includes(code)) {
                return setModalStatus(code);
            } else {
                Toast.error($t('fetch_fail'));
            }
        } finally {
            await getTotalViewActivity();
        }
    };

    onBeforeMount(async () => {
        // 预渲染不处理/无登录态
        if (isPreRender || !isLogin) {
            return;
        }
        await getTotalViewActivity();
    });

    return {
        receiveQuoteActivity
    };
};
